module.exports = __webpack_public_path__ + "static/emotional-health-0ba2775c71b672e7bf529bdb04b2b1be.jpg";